"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayRC4DecodeTemplate = StringArrayRC4DecodeTemplate;
function StringArrayRC4DecodeTemplate(randomGenerator) {
    const identifierLength = 6;
    const initializedIdentifier = randomGenerator.getRandomString(identifierLength);
    const rc4Identifier = randomGenerator.getRandomString(identifierLength);
    const dataIdentifier = randomGenerator.getRandomString(identifierLength);
    const onceIdentifier = randomGenerator.getRandomString(identifierLength);
    const cacheStateIdentifier = randomGenerator.getRandomString(identifierLength);
    return `
        if ({stringArrayCallsWrapperName}.${initializedIdentifier} === undefined) {
            {atobPolyfill}
            {rc4Polyfill}
            {stringArrayCallsWrapperName}.${rc4Identifier} = {rc4FunctionName};

            {stringArrayCallsWrapperName}.${dataIdentifier} = {};

            {stringArrayCallsWrapperName}.${initializedIdentifier} = true;
        }

        const firstValue = stringArray[0];

        if ({stringArrayCallsWrapperName}.${cacheStateIdentifier} !== firstValue) {
            {stringArrayCallsWrapperName}.${dataIdentifier} = {};
            {stringArrayCallsWrapperName}.${cacheStateIdentifier} = firstValue;
        }

        const cachedValue = {stringArrayCallsWrapperName}.${dataIdentifier}[index];

        if (cachedValue === undefined) {
            if ({stringArrayCallsWrapperName}.${onceIdentifier} === undefined) {
                {selfDefendingCode}

                {stringArrayCallsWrapperName}.${onceIdentifier} = true;
            }

            value = {stringArrayCallsWrapperName}.${rc4Identifier}(value, key);
            {stringArrayCallsWrapperName}.${dataIdentifier}[index] = value;
        } else {
            value = cachedValue;
        }
    `;
}
